import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IGetGameUrl } from '../../types/slot';
import { CasinoType } from 'modules/Casino/types/configuration';
import { getTab, isHiddenGame } from './utils';

class Converter implements ISlotConverter {
  convertGameList = ({
    data,
  }: IConvertGameList<{
    game_list?: Array<{
      id: number | string;
      name: string;
      iconImageUrl: string;
      externalData?: string;
    }>;
  }>): ISlotViewItem[] =>
    (data?.game_list ?? [])
      .filter(game => !isHiddenGame(String(game.id)))
      .map(game => ({
        id: String(game.id),
        gameId: String(game.id),
        gameName: game.name,
        description: game.name,
        routeProvider: 'galaxsys',
        provider: 'galaxsys',
        type: CasinoType.slots,
        tab: getTab(String(game.id)),
        imageUrl: game.iconImageUrl,
        technologyId: String(game.id),
        isLiveGame: game.externalData === 'tv',
      }));

  convertGameUrl = ({ data }: IGetGameUrl<string, unknown>) => data;
}

export default Converter;
